import React, { useState, useEffect, useMemo, useContext } from "react";
import axios from "axios";

import "../Usage/Usage.css";

// This is the update usage functionality in the build proposal view...

import StateUsage from "../UsageFunctions/StateUsage";
import MasterCalc from "../UsageFunctions/MasterCalc";
import PNMCalc from "../UsageFunctions/PNMCalc";
import BlackHillsCalc from "../UsageFunctions/BlackHillsCalc";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";

import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { auroraApi } from "../../api";
import { UserContext } from "../../UserContext";
import { Modal } from "../../shared/components/modal/Modal";

const Usage = (props) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const { activeUser, setActiveUser } = useContext(UserContext);

  const {
    preUsage,
    squareFootage,
    territory,
    projectID,
    zip,
    currentUser,
    salesTeam,
    customer,
    hasJurisdiction,
    jurisdictions = [],
  } = props;
  const {
    january,
    february,
    march,
    april,
    may,
    june,
    july,
    august,
    september,
    october,
    november,
    december,
  } = preUsage;

  const {
    tierType,
    surcharge,
    tax,
    tier1,
    tier2,
    tier3,
    tier4,
    sTier1,
    sTier2,
    sTier3,
    sTier4,
    wTier1,
    wTier2,
    wTier3,
    wTier4,
    tierAmount,
    sTierAmount,
    wTierAmount,
    tier1Amount,
    tier2Amount,
    tier3Amount,
    tier4Amount,
    sTier1Amount,
    sTier2Amount,
    sTier3Amount,
    sTier4Amount,
    wTier1Amount,
    wTier2Amount,
    wTier3Amount,
    wTier4Amount,
  } = props.calculation;

  let calcs = [
    tierType,
    +surcharge,
    +tax,
    +tier1,
    +tier2,
    +tier3,
    +tier4,
    +sTier1,
    +sTier2,
    +sTier3,
    +sTier4,
    +wTier1,
    +wTier2,
    +wTier3,
    +wTier4,
    +tierAmount,
    +sTierAmount,
    +wTierAmount,
    +tier1Amount,
    +tier2Amount,
    +tier3Amount,
    +tier4Amount,
    +sTier1Amount,
    +sTier2Amount,
    +sTier3Amount,
    +sTier4Amount,
    +wTier1Amount,
    +wTier2Amount,
    +wTier3Amount,
    +wTier4Amount,
  ];

  useEffect(() => {
    setJan(+january);
    setFeb(+february);
    setMar(+march);
    setApr(+april);
    setMa(+may);
    setJun(+june);
    setJul(+july);
    setAug(+august);
    setSep(+september);
    setOct(+october);
    setNov(+november);
    setDec(+december);
    setSqFoot(+squareFootage);
    // setAnnualUsage(+custUsage)
  }, [props]);

  const cancel = () => {
    setJan(+january);
    setFeb(+february);
    setMar(+march);
    setApr(+april);
    setMa(+may);
    setJun(+june);
    setJul(+july);
    setAug(+august);
    setSep(+september);
    setOct(+october);
    setNov(+november);
    setDec(+december);
  };

  const [annualUsage, setAnnualUsage] = useState("");
  const [usageType, setUsageType] = useState("");
  const [sqFoot, setSqFoot] = useState("");

  const [jan, setJan] = useState("");
  const [feb, setFeb] = useState("");
  const [mar, setMar] = useState("");
  const [apr, setApr] = useState("");
  const [ma, setMa] = useState("");
  const [jun, setJun] = useState("");
  const [jul, setJul] = useState("");
  const [aug, setAug] = useState("");
  const [sep, setSep] = useState("");
  const [oct, setOct] = useState("");
  const [nov, setNov] = useState("");
  const [dec, setDec] = useState("");

  const [loading, setLoading] = useState(false);

  const [jurisdiction, setJurisdiction] = useState("");

  const [edit, setEdit] = useState(false);
  const [dailyAvg, setDailyAvg] = useState("");

  // console.log(annualUsage)

  let annArray = [
    +jan,
    +feb,
    +mar,
    +apr,
    +ma,
    +jun,
    +jul,
    +aug,
    +sep,
    +oct,
    +nov,
    +dec,
  ];

  const total = (arr) => arr.reduce((a, b) => a + b);

  const { state } = props;

  // console.log(edit)

  // Set jurisdiction when hasJurisdiction prop is provided and jurisdictions are loaded
  useEffect(() => {
    if (hasJurisdiction && jurisdictions.length > 0) {
      const matchingJurisdiction = jurisdictions.find(
        (jur) => jur.name === hasJurisdiction,
      );
      if (matchingJurisdiction) {
        setJurisdiction(matchingJurisdiction.id);
      }
    }
  }, [hasJurisdiction, jurisdictions]);

  // console.log(preUsage, usage, newUsage)

  useEffect(() => {
    if (usageType === "Square Footage") {
      switch (territory) {
        case "Albuquerque":
          //setAnnualUsage(9503);
          break;
        case "Colorado Springs":
          //setAnnualUsage(9955);
          break;
        case "Buda":
          //setAnnualUsage(12479);
          break;
        case "Denver":
          //setAnnualUsage(10413);
          break;
        case "Dallas":
          //setAnnualUsage(12236);
          break;
        case "Las Vegas":
          if (sqFoot >= 4000) {
            //return setAnnualUsage(Math.round(2392.4 * Math.pow(+sqFoot, 0.25)));
          } else if (sqFoot < 4000 && sqFoot > 1000) {
            //return setAnnualUsage(Math.round(4.286 * +sqFoot + 1882));
          } else if (sqFoot <= 1000) {
            //return setAnnualUsage(Math.round(195.05 * Math.pow(+sqFoot, 0.5)));
          }
          break;
        case "Utah":
          //setAnnualUsage(10639);
          break;
        case "Oregon":
          //setAnnualUsage(9687);
          break;
        case "North Carolina":
          //setAnnualUsage(13100);
          break;
        case "Richmond":
          //setAnnualUsage(16126);
          break;
        case "Virginia Beach":
          //setAnnualUsage(15052);
          break;
        default:
          //setAnnualUsage(12475);
      }
      // if (territory === 'Las Vegas') {

      // }
      //   if (sqFoot >= 4000) {
      //   return setAnnualUsage(Math.round(2392.4 * Math.pow(+sqFoot, .25)))
      // } else if (sqFoot < 4000 && sqFoot > 1000) {
      //   return setAnnualUsage(Math.round(4.286 * +sqFoot + 1882))
      // } else if (sqFoot <= 1000) {
      //     return setAnnualUsage(Math.round(195.05 * Math.pow(+sqFoot, .5)))
      //   }
    }
  }, [usageType, sqFoot]);

  let newUsage = StateUsage(state, annArray, annualUsage, usageType);

  if (newUsage) {
    annArray = newUsage;
  }

  let billCalc;

  // console.log(total(newUsage))

  switch (props.utility) {
    case "PNM - Public Service Company of New Mexico":
    case "Continental Divide Electric":
    case "CNM":
      billCalc = PNMCalc(newUsage);
      break;
    case "Black Hills Electric":
      billCalc = BlackHillsCalc(newUsage);
      break;
    default:
      billCalc = MasterCalc(newUsage, calcs);
  }

  // console.log(squareFootage, annualUsage)

  let mappedJurisdictions = jurisdictions.map((jur, i) => {
    let info = [jur.id];
    return (
      <option key={i} value={info}>
        {" "}
        {jur.name} Offset:{" "}
        {jur.offset === "Yes"
          ? "3 ft"
          : jur.offset === "No"
            ? "1/2 ft"
            : jur.offset === false
              ? "Unknown"
              : jur.offset}
      </option>
    );
  });

  // This will get the aurora design link from the email address and open it in a new tab

  // This will set the usage for the project and will create/sync the design to aurora
  const updateUsage = async () => {
    setLoading(true);

    try {
      // Update the customers usage and create the project in Aurora if it doesn't exist.
      await auroraApi.updateUsage({
        id: props.designId,
        id2: projectID,
        Annual_kW_Usage__c: total(newUsage),
        January_Usage__c: jan,
        February_Usage__c: feb,
        March_Usage__c: mar,
        April_Usage__c: apr,
        May_Usage__c: ma,
        June_Usage__c: jun,
        July_Usage__c: jul,
        August_Usage__c: aug,
        September_Usage__c: sep,
        October_Usage__c: oct,
        November_Usage__c: nov,
        December_Usage__c: dec,
        Usage_type__c: usageType,
        Square_Footage__c: sqFoot,
        Current_Avg_Bill__c: billCalc[1],
        Associated_Jurisdiction__c: jurisdiction,
        user: currentUser,
      });

      // After both operations, update state and fetch customer data
      setEdit(!edit);
      props.getCustomer(); // Call this only after successful project creation and update
    } catch (error) {
      console.error("Error updating usage:", error);
    } finally {
      setLoading(false);
    }
  };

  // console.log(annualUsage, usageType, territory)

  const optionsConfig = {
    default: [
      { value: "Full 12 Months", label: "Full 12 Months" },
      { value: "Partial 12 Months", label: "Partial 12 Months" },
      { value: "Square Footage", label: "Square Footage" },
      { value: "Annual", label: "Annual" },
      { value: "Annual - Square Footage", label: "Annual - Square Footage" },
    ],
    noPartial: [
      { value: "Full 12 Months", label: "Full 12 Months" },
      { value: "Square Footage", label: "Square Footage" },
      { value: "Annual", label: "Annual" },
      { value: "Annual - Square Footage", label: "Annual - Square Footage" },
    ],
  };

  let selectedOptions = optionsConfig.default;

  if (!props.maximumOverDrive) {
    if (props.utility === "NV Energy") {
      selectedOptions = optionsConfig.noPartial;
    }
  }

  let mappedOptions = selectedOptions.map((option, i) => {
    return (
      <option key={i} value={option.value}>
        {option.label}
      </option>
    );
  });

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="h-100 ps-5 pe-3 pt-3 text-white bg-dark text-start" style={{ borderRadius: "5px 5px 0 0" }}>
              <h4 className="float-start mb-4 pt-1">
                {" "}
                {customer.name}'s Current Utility Info
              </h4>

              <button
                className="btn btn-outline-light float-end"
                type="button"
                onClick={() => setEdit(true)}
              >
                Update Usage
              </button>
            </div>
          </div>
        </div>
      </div>

        <Modal
          isOpen={edit}
          onClose={() => {
            setEdit(false);
            cancel();
          }}
          title="Update Usage"
          className="extra-large"
          closeOnOverlayClick={false}
          footer={
            <>
              <button
                type="button"
                className="btn btn-primary"
                disabled={loading}
                onClick={() => updateUsage()}
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  "Update Usage"
                )}
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  setEdit(false);
                  cancel();
                }}
              >
                Cancel
              </button>
            </>
          }
        >
         
 <div className="row">
            <div className="col-md-12">
              <div>
                <div>
                  <select
                    className="form-select w-50"
                    onChange={(e) => setUsageType(e.target.value)}
                  >
                    <option style={{ display: "none" }}> Usage Type </option>
                    {mappedOptions}
                  </select>
                </div>
                {usageType === "Annual" || usageType === "Annual - Square Footage" ? (
                  <>
                    <div className="text-start ms-1 text-dark mt-3">Total Annual Usage (kWh)</div>
                    <input
                      className="form-control w-50"
                      value={annualUsage}
                      onChange={(e) => setAnnualUsage(+e.target.value)}
                    ></input>{" "}
                  
                  </>
                ) : (
                  <></>
                )}
                {usageType === "Square Footage" ? (
                  <>
                    <div className="text-start ms-1 text-dark mt-3">Total Square Footage of Home</div>
                    <input
                      className="form-control w-50"
                      value={sqFoot}
                      onChange={(e) => setSqFoot(+e.target.value)}
                    ></input>
                 
                  </>
                ) : (
                  <></>
                )}
              </div>
              {usageType === "Full 12 Months" ||
              usageType === "Partial 12 Months" ? (
                <>
                  <form className="text-dark text-start ms-1 mt-2">
                    <span>Daily Average Usage? </span>
                    <span className="ms-2">Yes</span>
                    <input
                      className="form-check-input ms-1"
                      type="radio"
                      name="dailyAvg"
                      onChange={(e) => setDailyAvg("1")}
                      checked={dailyAvg === "1" ? "checked" : ""}
                    />
                    <span className="ms-2">No</span>
                    <input
                      className="form-check-input ms-1"
                      type="radio"
                      name="dailyAvg"
                      onChange={(e) => setDailyAvg("0")}
                      checked={dailyAvg === "0" ? "checked" : ""}
                    />
                  </form>
                  {dailyAvg === "0" ? (
                    <>
                      <h3 className="usage-section-header">
                        Full Monthly Usage
                      </h3>
                      <div className="row">
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="January"
                            onChange={(e) => setJan(+e.target.value)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="February"
                            onChange={(e) => setFeb(+e.target.value)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="March"
                            onChange={(e) => setMar(+e.target.value)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="April"
                            onChange={(e) => setApr(+e.target.value)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="May"
                            onChange={(e) => setMa(+e.target.value)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="June"
                            onChange={(e) => setJun(+e.target.value)}
                          ></input>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-2">
                        <span className="">January: {jan} </span></div>
                        <div className="col-sm-2">
                        <span className="">February: {feb} </span>
                        </div>
                        <div className="col-sm-2">
                        <span className="">March: {mar} </span>
                        </div>
                        <div className="col-sm-2">
                        <span className="">April: {apr} </span>
                        </div>
                        <div className="col-sm-2">
                        <span className="">May: {ma} </span>
                        </div>
                        <div className="col-sm-2">
                        <span className="">June: {jun} </span>
                        </div>
                      </div>
                      
                      <div className="row mt-4">
                        <div className="col-sm-2">
                        <input
                          className="form-control"
                          placeholder="July"
                          onChange={(e) => setJul(+e.target.value)}
                        ></input>
                        </div>
                        <div className="col-sm-2">
                        <input
                          className="form-control"
                          placeholder="August"
                          onChange={(e) => setAug(+e.target.value)}
                        ></input>
                        </div>
                        <div className="col-sm-2">
                        <input
                          className="form-control"
                          placeholder="September"
                          onChange={(e) => setSep(+e.target.value)}
                        ></input>
                        </div>
                        <div className="col-sm-2">
                        <input
                          className="form-control"
                          placeholder="October"
                          onChange={(e) => setOct(+e.target.value)}
                        ></input>
                        </div>
                        <div className="col-sm-2">
                        <input
                          className="form-control"
                          placeholder="November"
                          onChange={(e) => setNov(+e.target.value)}
                        ></input>
                        </div>
                        <div className="col-sm-2">
                        <input
                          className="form-control"
                          placeholder="December"
                          onChange={(e) => setDec(+e.target.value)}
                        ></input>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-2">
                        <span className="">July: {jul} </span></div>
                        <div className="col-sm-2">
                        <span className="">August: {aug} </span></div>
                        <div className="col-sm-2">
                        <span className="">September: {sep} </span></div>
                        <div className="col-sm-2">
                        <span className="">October: {oct} </span></div>
                        <div className="col-sm-2">
                        <span className="">November: {nov} </span></div>
                        <div className="col-sm-2">
                        <span className="">December: {dec} </span></div>
                      </div>

                      <div>
                        {/* <button style={{ marginTop: '1rem' }} onClick={() => updateUsage()}>Add Usage</button> */}
                      </div>
                    </>
                  ) : dailyAvg === "1" ? (
                    <>
                      <h3 className="usage-section-header">Daily Average Usage</h3>
                      <div className="row">
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="January"
                            onChange={(e) => setJan(+e.target.value * 31)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="February"
                            onChange={(e) => setFeb(+e.target.value * 28)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="March"
                            onChange={(e) => setMar(+e.target.value * 31)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="April"
                            onChange={(e) => setApr(+e.target.value * 30)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="May"
                            onChange={(e) => setMa(+e.target.value * 31)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="June"
                            onChange={(e) => setJun(+e.target.value * 30)}
                          ></input>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-2">
                          <span className="">January: {jan} </span>
                        </div>
                        <div className="col-sm-2">
                          <span className="">February: {feb} </span>
                        </div>
                        <div className="col-sm-2">
                          <span className="">March: {mar} </span>
                        </div>
                        <div className="col-sm-2">
                          <span className="">April: {apr} </span>
                        </div>
                        <div className="col-sm-2">
                          <span className="">May: {ma} </span>
                        </div>
                        <div className="col-sm-2">
                          <span className="">June: {jun} </span>
                        </div>
                      </div>
                      <div className="row mt-4">
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="July"
                            onChange={(e) => setJul(+e.target.value * 31)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="August"
                            onChange={(e) => setAug(+e.target.value * 31)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="September"
                            onChange={(e) => setSep(+e.target.value * 30)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="October"
                            onChange={(e) => setOct(+e.target.value * 31)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="November"
                            onChange={(e) => setNov(+e.target.value * 30)}
                          ></input>
                        </div>
                        <div className="col-sm-2">
                          <input
                            className="form-control"
                            placeholder="December"
                            onChange={(e) => setDec(+e.target.value * 31)}
                          ></input>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-2">
                          <span className="">July: {jul} </span>
                        </div>
                        <div className="col-sm-2">
                          <span className="">August: {aug} </span>
                        </div>
                        <div className="col-sm-2">
                          <span className="">September: {sep} </span>
                        </div>
                        <div className="col-sm-2">
                          <span className="">October: {oct} </span>
                        </div>
                        <div className="col-sm-2">
                          <span className="">November: {nov} </span>
                        </div>
                        <div className="col-sm-2">
                          <span className="">December: {dec} </span>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </Modal>
        {showError ? (
          <>
            <div className="row justify-content-center">
              <div className="col" align="center">
                <div className="errorMessage">{errorMessage}</div>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
    </>
  );
};
export default Usage;
